module.exports = __webpack_public_path__ + "img/envelope.b580ca11.jpg";